/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostStoryRequest
 */
export interface PostStoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PostStoryRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PostStoryRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof PostStoryRequest
     */
    handleName: string;
}

/**
 * Check if a given object implements the PostStoryRequest interface.
 */
export function instanceOfPostStoryRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "body" in value;
    isInstance = isInstance && "handleName" in value;

    return isInstance;
}

export function PostStoryRequestFromJSON(json: any): PostStoryRequest {
    return PostStoryRequestFromJSONTyped(json, false);
}

export function PostStoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostStoryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': json['body'],
        'handleName': json['handleName'],
    };
}

export function PostStoryRequestToJSON(value?: PostStoryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'body': value.body,
        'handleName': value.handleName,
    };
}

